/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { CreateTimeEntryRequestAppointmentId } from './CreateTimeEntryRequestAppointmentId';
import {
    CreateTimeEntryRequestAppointmentIdFromJSON,
    CreateTimeEntryRequestAppointmentIdFromJSONTyped,
    CreateTimeEntryRequestAppointmentIdToJSON,
    CreateTimeEntryRequestAppointmentIdToJSONTyped,
} from './CreateTimeEntryRequestAppointmentId';

/**
 * 
 * @export
 * @interface UpdateTimeEntryRequest
 */
export interface UpdateTimeEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryRequest
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateTimeEntryRequest
     */
    entryDate: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryRequest
     */
    clockIn: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryRequest
     */
    clockOut: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateTimeEntryRequest
     */
    timeEntryTypeId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof UpdateTimeEntryRequest
     */
    appointmentId: CreateTimeEntryRequestAppointmentId | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryRequest
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the UpdateTimeEntryRequest interface.
 */
export function instanceOfUpdateTimeEntryRequest(value: object): value is UpdateTimeEntryRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entryDate' in value) || value['entryDate'] === undefined) return false;
    if (!('clockIn' in value) || value['clockIn'] === undefined) return false;
    if (!('clockOut' in value) || value['clockOut'] === undefined) return false;
    if (!('timeEntryTypeId' in value) || value['timeEntryTypeId'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function UpdateTimeEntryRequestFromJSON(json: any): UpdateTimeEntryRequest {
    return UpdateTimeEntryRequestFromJSONTyped(json, false);
}

export function UpdateTimeEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTimeEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entryDate': (new Date(json['entryDate'])),
        'clockIn': json['clockIn'],
        'clockOut': json['clockOut'],
        'timeEntryTypeId': ActorActivityRecordActorUserIdFromJSON(json['timeEntryTypeId']),
        'appointmentId': CreateTimeEntryRequestAppointmentIdFromJSON(json['appointmentId']),
        'remarks': json['remarks'],
    };
}

export function UpdateTimeEntryRequestToJSON(json: any): UpdateTimeEntryRequest {
    return UpdateTimeEntryRequestToJSONTyped(json, false);
}

export function UpdateTimeEntryRequestToJSONTyped(value?: UpdateTimeEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entryDate': value['entryDate'].toISOString().substring(0,10),
        'clockIn': value['clockIn'],
        'clockOut': value['clockOut'],
        'timeEntryTypeId': ActorActivityRecordActorUserIdToJSON(value['timeEntryTypeId']),
        'appointmentId': CreateTimeEntryRequestAppointmentIdToJSON(value['appointmentId']),
        'remarks': value['remarks'],
    };
}

